import { secureLocalStorage } from '~/utils/secureStorage'
import packageJson from '../../../../../../package.json'
import { fetchWithTimeout } from './fetchWithTimeout'

const CURRENT_VERSION = packageJson.version
const API_URL = process.env.REACT_APP_API_URL || 'https://www.app.xmati.ai/apis'
const getToken = () => secureLocalStorage.getItem('jwt') || ''

export const checkAccountStatus = async (email: string) => {
  const token = getToken()
  return fetchWithTimeout(
    `${API_URL}/check-account-status`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({}),
    },
    10000
  )
}

// export const getJwtToken = async (email: string) => {
//   return fetchWithTimeout(
//     `${API_URL}/get-jwt-token`,
//     {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({ email }),
//     },
//     10000
//   )
// }

// export const getAesKey = async (email: string) => {
//   return fetchWithTimeout(
//     `${API_URL}/get-aes-key`,
//     {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({ email }),
//     },
//     10000
//   )
// }

export const getFullData = async (email: string) => {
  const token = getToken()
  const data = await fetchWithTimeout(
    `${API_URL}/get-full-data`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-App-Version': CURRENT_VERSION,
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({}),
    },
    10000
  )

  return data
}
